import React from 'react';
import flatten from 'lodash/flatten';
import cn from 'classnames';
import {
  RankYearsNavArrowsLeftContainer,
  RankYearsNavArrowsRightContainer,
  TableYearsNavArrowsLeftContainer,
  TableYearsNavArrowsRightContainer,
} from './TableYearsNavArrows';
import {
  ICategoryItem,
  ICategoryRow,
  IColumnScorecard,
} from '@/creditflowresearch/application/League/interfaces';
import {
  IPeriod,
  ICategoryScorecard,
} from '@/creditflowresearch/domain/vo/League/IStandings';

import standingStyles from './standingTable.module.scss';

export const getCategories = (
  categories:ICategoryScorecard[],
  callback:(id:string) => void,
):ICategoryItem[] => [
  ...flatten(categories.map((category) => ([
    {
      key: category.id,
      hasSubItems: true,
      data: category,
      onClick: () => callback(category.id),
    },
    ...(category.subcategories.length && category.subcategories.map((subcategory) => ({
      key: subcategory.id,
      data: subcategory,
    }))) || [],
  ]))),
];

export const getRankYearHeaderColumns = (
  periods:IPeriod[],
  getYearCell:(props:IColumnScorecard) => React.ReactNode,
):IColumnScorecard[] => [
  {
    name: 'arrowLeft',
    className: cn(standingStyles.yearHeaderColumn, standingStyles.yearHeaderArrowCell),
    title: '',
    headCallback: () => <RankYearsNavArrowsLeftContainer />,
  },
  ...periods.map((period) => (
    {
      name: `count-${ period.name }`,
      title: period.name,
      className: standingStyles.yearHeaderColumn,
      headCallback: getYearCell,
    }
  )),
  {
    name: 'arrowRight',
    className: cn(standingStyles.yearHeaderColumn, standingStyles.yearHeaderArrowCell),
    title: '',
    headCallback: () => <RankYearsNavArrowsRightContainer />,
  },
];

export const getYearHeaderColumns = (
  periods:IPeriod[],
  getYearCell:(props:IColumnScorecard) => React.ReactNode,
):IColumnScorecard[] => [
  {
    name: 'arrowLeft',
    className: cn(standingStyles.yearHeaderColumn, standingStyles.yearHeaderArrowCell),
    title: '',
    headCallback: () => <TableYearsNavArrowsLeftContainer />,
  },
  ...periods.map((period) => ({
    name: period.name,
    title: period.name,
    className: standingStyles.yearHeaderColumn,
    headCallback: getYearCell,
  })),
  {
    name: 'arrowRight',
    className: cn(standingStyles.yearHeaderColumn, standingStyles.yearHeaderArrowCell),
    title: '',
    headCallback: () => <TableYearsNavArrowsRightContainer />,
  },
];

export const getLegendHeaderColumns = (
  periods:IPeriod[],
  getLegendCell:(props:IColumnScorecard) => React.ReactNode,
):IColumnScorecard[] => [
  {
    name: 'arrowLeft',
    className: standingStyles.legendHeaderColumn,
    title: '',
    isVisible: periods.length !== 1,
  },
  ...periods.map((period) => ({
    name: `count-${ period.name }`,
    className: standingStyles.legendHeaderColumn,
    title: '',
    headCallback: getLegendCell,
    colSpan: periods.length === 1 ? 3 : 1,
  })),
  {
    name: 'arrowRight',
    className: standingStyles.legendHeaderColumn,
    title: '',
    isVisible: periods.length !== 1,
  },
];

export const getTableRows = (categories:ICategoryScorecard[]):ICategoryRow[] => [
  ...flatten(categories.map((category) => ([
    {
      key: category.id,
      periods: category.periods,
      categoryId: category.id,
    },
    ...(category.subcategories.length && category.subcategories.map((subcategory) => ({
      key: subcategory.id,
      periods: subcategory.periods,
      categoryId: subcategory.categoryId,
      subCategoryId: subcategory.id,
    }))) || [],
  ]))),
];
